/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const onclick = document.querySelectorAll(".OnClick_src");
const iframe = document.querySelector(".FeaturedMap__G");
onclick.forEach((f) =>
  f.addEventListener("click", (event) => {
    var src = f.getAttribute("data-src");
    iframe.innerHTML = src;
  })
);

// external js: flickity.pkgd.js
var cellsButtonGroup = document.querySelector(".button-group--cells");
if (cellsButtonGroup) {
  var utils = window.fizzyUIUtils;

  var carousel = document.querySelector(".Carousel--new");
  var flkty = new Flickity(carousel, {
    prevNextButtons: false,
    pageDots: false,
  });
}
// elements

if (cellsButtonGroup) {
  var cellsButtons = utils.makeArray(cellsButtonGroup.children);
}
// update buttons on select
if (cellsButtonGroup) {
  flkty.on("select", function () {
    var previousSelectedButton = cellsButtonGroup.querySelector(".is-selected");
    var selectedButton = cellsButtonGroup.children[flkty.selectedIndex];
    previousSelectedButton.classList.remove("is-selected");
    selectedButton.classList.add("is-selected");
    selectedButton.addEventListener("click", function (event) {
      console.log(event.target.dataset.href);
      window.location.href = event.target.dataset.href;
    });
  });
}

// cell select
if (cellsButtonGroup && cellsButtons) {
  cellsButtonGroup.addEventListener("click", function (event) {
    if (!matchesSelector(event.target, ".button")) {
      console.log("FOundit");
      return;
    }
    var index = cellsButtons.indexOf(event.target);
    flkty.select(index);
  });
}
// previous
var previousButton = document.querySelector(".button--previous");
if (previousButton) {
  previousButton.addEventListener("click", function () {
    flkty.previous();
  });
}
// next

var nextButton = document.querySelector(".button--next");
if (nextButton) {
  nextButton.addEventListener("click", function () {
    flkty.next();
  });
}

document.querySelectorAll("#expand-trigger").forEach((btn) => {
  btn.addEventListener("click", (event) => {
    if (btn.className == "readmore") {
      let currentcontainer = btn.parentElement.parentElement.parentElement;
      currentcontainer.querySelector("#description-full").style.display =
        "block";
      currentcontainer.querySelector("#description-short").style.display =
        "none";
    } else {
      let currentcontainer = btn.parentElement.parentElement.parentElement;
      currentcontainer.querySelector("#description-full").style.display =
        "none";
      currentcontainer.querySelector("#description-short").style.display =
        "block";
    }
  });
});

const headercontainer = document.getElementById("shopify-section-header");
var lastScrollTop = document.documentElement.scrollTop;

window.addEventListener(
  "scroll",
  function () {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      headercontainer.style.top = "0";
    } else {
      headercontainer.style.top = "0";
    }
    lastScrollTop = st <= 0 ? 0 : st;
  },
  false
);

var timepassed = null;
window.addEventListener(
  "scroll",
  function () {
    if (timepassed !== null) {
      clearTimeout(timepassed);
    }
    timepassed = setTimeout(function () {
      headercontainer.style.top = "0";
    }, 450);
  },
  false
);

let checkvalue = document.getElementsByClassName(
  "ImageHero__Image--parallax-custom"
);
if (checkvalue.length > 0) {
  let relaxwrapper = document.querySelector(".FeatureText");
  relaxwrapper.parallaxInstance = new Rellax(
    ".ImageHero__Image--parallax-custom",
    {
      speed: 3,
      center: true,
      round: false,
    }
  );
}
// let relaxwrapper = document.querySelector('.ImageHero__Image--parallax-custom')

// Mobile search close
var SortFilter = document.querySelector(".side-search");
var searchdrawer = document.querySelector(".Search");
var toggleState = function (elem, one, two) {
  var elem = document.querySelector(elem);
  elem.setAttribute(
    "aria-hidden",
    elem.getAttribute("aria-hidden") === one ? two : one
  );
};
if (SortFilter) {
  var removeisvisble = document.querySelector("#page-overlay");
  SortFilter.onclick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleState("#sidebar-menu", "true", "false");
    toggleState("#Search", "false", "true");
    removeisvisble.classList.remove("is-visible");
  };
}

const scrollbtn = document.querySelector(".scroll-btn");
if (scrollbtn) {
  scrollbtn.addEventListener("click", function () {
    window.scrollTo(0, window.scrollY + window.innerHeight);
  });
}

const sliders = document.querySelector(".main-scroll-sec");
let isDowns = false;
let startXs;
let scrollLefts;
if (sliders) {
  sliders.addEventListener("mousedown", (e) => {
    isDowns = true;
    sliders.classList.add("active");
    startXs = e.pageX - sliders.offsetLeft;
    scrollLefts = sliders.scrollLeft;
  });
  sliders.addEventListener("mouseleave", () => {
    isDowns = false;
    sliders.classList.remove("active");
  });
  sliders.addEventListener("mouseup", () => {
    isDowns = false;
    sliders.classList.remove("active");
  });
  sliders.addEventListener("mousemove", (e) => {
    if (!isDowns) return;
    e.preventDefault();
    const x = e.pageX - sliders.offsetLeft;
    const walk = (x - startXs) * 3; //scroll-fast
    sliders.scrollLeft = scrollLefts - walk;
    console.log(walk);
  });
}

const sliderss = document.querySelector(".CertificationList");
let isDownss = false;
let startXss;
let scrollLeftss;

if (sliderss) {
  sliderss.addEventListener("mousedown", (e) => {
    isDownss = true;
    sliderss.classList.add("active");
    startXss = e.pageX - sliderss.offsetLeft;
    scrollLeftss = sliderss.scrollLeft;
  });
  sliderss.addEventListener("mouseleave", () => {
    isDownss = false;
    sliderss.classList.remove("active");
  });
  sliderss.addEventListener("mouseup", () => {
    isDownss = false;
    sliderss.classList.remove("active");
  });
  sliderss.addEventListener("mousemove", (e) => {
    if (!isDownss) return;
    e.preventDefault();
    const x = e.pageX - sliderss.offsetLeft;
    const walk = (x - startXss) * 3; //scroll-fast
    sliderss.scrollLeft = scrollLeftss - walk;
    console.log(walk);
  });
}

const currentparams = window.location.search;
const cityurl = new URLSearchParams(currentparams);
var cityid = cityurl.get("cityid");
if (cityid != null) {
  window.addEventListener("DOMContentLoaded", (event) => {
    document.getElementById(cityid).click();
  });
}
